import React from 'react';

const NotFoundPage = () => (
  <div>
    <br />
    <p style={{ textAlign: 'center' }}>404: Page not found</p>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.jsx